<template>
  <div class="mbti-home">
      <div class="button-section">
        <button class="btn primary-btn" @click="goToTest">进入测评</button>
        <button class="btn secondary-btn" @click="goToResult">
          查看测评结果
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MBTIHome",
  methods: {
    goToTest() {
      this.$router.push("/mbti-action");
    },
    goToResult() {
      const openid =
        localStorage.getItem("openId") || localStorage.getItem("openid") || "";
      if (openid) {
        this.$router.push({
          path: "/mbti-result",
          query: { openid: openid, wjId: "1" },
        });
      } else {
        this.$message.warning("暂无微信登录信息，请先完成登录");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.mbti-home {
  height: 100vh;
  background: url("~@/assets/images/mbti-home-bg.png") no-repeat center center;
  background-size: cover;
  padding: 20px;
}

.header {
  text-align: center;
  margin-bottom: 40px;
}

.header h1 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo-section {
  margin-bottom: 30px;
}

.logos {
  display: flex;
  align-items: center;
  gap: 20px;
}

.logo-item {
  font-size: 14px;
  color: #666;
}

.content h2 {
  font-size: 28px;
  font-weight: 700;
  color: #333;
  margin-bottom: 15px;
}

.hashtag {
  font-size: 24px;
  font-weight: 700;
  color: #ff6b00;
  margin-bottom: 10px;
}

.content p {
  font-size: 16px;
  color: #666;
  margin-bottom: 40px;
}

.image-section {
  width: 200px;
  height: 200px;
  margin-bottom: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.books {
  position: relative;
  width: 150px;
  height: 150px;
}

.book {
  position: absolute;
  border-radius: 8px;
  background: #ffb800;
}

.book-1 {
  width: 120px;
  height: 30px;
  bottom: 0;
  left: 15px;
}

.book-2 {
  width: 130px;
  height: 30px;
  bottom: 35px;
  left: 10px;
}

.book-3 {
  width: 140px;
  height: 30px;
  bottom: 70px;
  left: 5px;
  border-radius: 8px 8px 0 0;
}

.book-3::after {
  content: "";
  position: absolute;
  top: -15px;
  right: 20px;
  width: 40px;
  height: 20px;
  background: #ffd700;
  border-radius: 4px 4px 0 0;
  transform: rotate(45deg);
}

.button-section {
  position: absolute;
  bottom: 120px;
  left: 40px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  width: 300px;
}

.btn {
  width: 100%;
  padding: 15px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.primary-btn {
  background: linear-gradient(135deg, #ffb800 0%, #ff6b00 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(255, 107, 0, 0.3);
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 107, 0, 0.4);
}

.secondary-btn {
  background: #fff;
  color: #333;
  border: 1px solid #e0e0e0;
}

.secondary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
</style>

<style>
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "PingFang SC", "Helvetica Neue", Arial, sans-serif;
  background-color: #fff;
  color: #333;
}
</style>